<h1 mat-dialog-title>Select Roadbooks</h1>
<div mat-dialog-content>
    <mat-form-field>
        <input matInput [(ngModel)]="folder.n" placeholder="Name">
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button [mat-dialog-close]="folder" cdkFocusInitial class="btn btn-success" [disabled]="!folder.n">Select</button>
    <button style="margin-left: 20px" (click)="cancel()" class="btn btn-danger">Cancel</button>
</div>